module.exports = __webpack_public_path__ + "static/media/theft.50ced937.svg";